import { useCallback } from 'react'

import { browserHistory } from 'react-router'

import type { SubscriptionSettingsAnalytics } from '@library/api-customer-engagement-experience'
import { queueTrackingEvent } from '@library/tracking-integration'

export const RESUB_OPTIMISATION_INTENTS = {
  reactivateSubscription: 'reactivate_subscription',
  startOneOffOrder: 'start_one_off_order',
} as const

// Reuses OrderABox's existing one-off-order destination (a plain navigation, not the
// startOneOffOrder thunk GoustoAnytime dispatches) — see PausedSubscription/sections/OrderABox.
const ONE_OFF_ORDER_DESTINATION = '/menu'

type UseResubOptimisationIntentHandlerResult = {
  onAction: (intent: string, analytics?: SubscriptionSettingsAnalytics) => void
}

export function useResubOptimisationIntentHandler(
  onResubscribe?: () => void,
): UseResubOptimisationIntentHandlerResult {
  const onAction = useCallback(
    (intent: string, analytics?: SubscriptionSettingsAnalytics): void => {
      switch (intent) {
        case RESUB_OPTIMISATION_INTENTS.startOneOffOrder:
          if (analytics) {
            queueTrackingEvent<SubscriptionSettingsAnalytics>(analytics)
          }
          browserHistory.push(ONE_OFF_ORDER_DESTINATION)

          return

        // reactivate_subscription opens the resubscribe confirmation screen through the host's
        // onResubscribe callback.
        case RESUB_OPTIMISATION_INTENTS.reactivateSubscription:
          if (analytics) {
            queueTrackingEvent<SubscriptionSettingsAnalytics>(analytics)
          }
          onResubscribe?.()

          return

        default:
          return
      }
    },
    [onResubscribe],
  )

  return { onAction }
}
